/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/scalb.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the result of `d * 2 ^ scaleFactor`,
 * Similar to Java's `scalb` function. Result is rounded as if
 * performed by a single correctly rounded floating-point multiply
 * to a member of the double value set.
 *
 * @example
 * row x = 3.0, y = 10 | eval z = scalb(x, y)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'scalb',
  signatures: [
    {
      params: [
        {
          name: 'd',
          type: 'double',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'double',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'integer',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'integer',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'long',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'long',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'd',
          type: 'unsigned_long',
          optional: false,
        },
        {
          name: 'scaleFactor',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
